import { useTranslation, Trans } from "react-i18next";
import { Link } from "react-router-dom";
import { trackCTA } from "../utils/eventTracker";
import BackgroundImage from "../components/BackgroundImage";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";

export default function Services() {
  const { t } = useTranslation();
  return (
    <div className="page-wrapper">
      <BackgroundImage />
      <NavBar />
      <div className="transparency-wrapper">
        {/* SERVICES */}

        <section className="section-block padding column">
          <div className="testimonial-section">
            <div className="section-text-centered-wrapper no-margin-top">
              <div className="section-title-centered neon-glow">
                {t("servicesSectionTitle")}
              </div>
            </div>
            {/* PCB & FIRMWARE */}
            <section className="section-block">
              <div className="services-block">
                <div className="service-image">
                  <img
                    src="/images/PCB&Firmware.webp"
                    alt="PCB & Firmware"
                    loading="lazy"
                    className="box-glow"
                  />
                </div>
                <div className="services-text-block card-box">
                  <h2 className="section-text-main">{t("firmwareTitle")}</h2>
                  <p className="section-text-secondary">
                    <Trans i18nKey="firmwareParagraph" />
                  </p>
                </div>
              </div>
            </section>
            {/* PCB & FIRMWARE CTA */}
            <div className="cta-button-secondary-wrapper">
              <Link
                to="/quote"
                className="cta-button-secondary"
                onClick={() => trackCTA("PCB&firmware")}
              >
                {t("ctaBookCall")}
              </Link>
            </div>

            {/* WEB & MOBILE */}
            <section className="section-block">
              <div className="services-block">
                <div className="services-text-block card-box">
                  <h2 className="section-text-main">{t("mobileTitle")}</h2>
                  <p className="section-text-secondary">
                    <Trans i18nKey="mobileParagraph" />
                  </p>
                </div>

                <div className="service-image">
                  <img
                    src="/images/Mobile&Web.webp"
                    alt="Mobile & Web"
                    loading="lazy"
                    className="box-glow"
                  />
                </div>
              </div>
            </section>
            {/* WEB & MOBILE CTA */}
            <div className="cta-button-secondary-wrapper">
              <Link
                to="/quote"
                className="cta-button-secondary"
                onClick={() => trackCTA("web&mobile")}
              >
                {t("ctaContactMe")}
              </Link>
            </div>
          </div>

          {/* BACKEND & CLOUD */}
          <section className="section-block">
            <div className="services-block">
              <div className="service-image">
                <img
                  src="/images/Backend&Cloud.webp"
                  alt="Backend & Cloud"
                  loading="lazy"
                  className="box-glow"
                />
              </div>
              <div className="services-text-block card-box">
                <h2 className="section-text-main">{t("backendTitle")}</h2>
                <p className="section-text-secondary">
                  <Trans i18nKey="backendParagraph" />
                </p>
              </div>
            </div>
          </section>
          {/* CTA  BACKEND & CLOUD */}
          <div className="cta-button-secondary-wrapper">
            <Link
              to="/quote"
              className="cta-button-secondary"
              onClick={() => trackCTA("backend&Cloud")}
            >
              {t("ctaTalkDetails")}
            </Link>
          </div>
        </section>
        {/**/}
        <Footer />
      </div>
    </div>
  );
}
